module.exports = __webpack_public_path__ + "img/edit-standby.c36c6f72.svg";